<script>
import { defineAsyncComponent } from "vue";
import { componentStore } from "@common/componentStore/componentStore";
import { library } from "@common/library/library";
import { TabItemDirective, TabItemsDirective } from "@syncfusion/ej2-vue-navigations/src/tab/items.directive";
import { actionStore } from "@common/actionStore";
import { ddStore } from "@common/ddStore";
import { controlStore, createStoreIndex } from "@common/control/controlStore";

const vmsAffiliationGridConfig = {
    cId: "vmsAffiliationGrid",
    cType: "vmsAffiliationGrid",
    cTitle: "Affiliation Grid",
    cTemplate: `<div class="vms-affiliation-grid-wrapper" :id="'vmsAffiliationGridWrapper' + cId" :class="{ 'from-main-grid': fromMainGrid }">
                    <div class="vms-affiliation-grid-parts">
                        <div class="leftcolumn">
                            <div v-if="!reloadButtons" v-for="(item, index) in leftMenu" :key="index">
                                <control :name="item.name"></control>
                            </div>
                        </div>
                        <div class="rightcolumn">
                            <grid-main :c-id="'gridMain_mainGrid__AFF'"
                            :ref="'grid_mainGrid__AFF'"
                            :prop-psp="32"
                            :prop-selected-folder="3"
                            @update:prop-selected-folder="selectedFolder = $event;"
                            :prop-selected-items="selectedItems"
                            @update:prop-selected-items="selectedItems = $event;"
                            :prop-selected-items-full-data="selectedItemsFullData"
                            @update:prop-selected-items-full-data="selectedItemsFullData = $event; disableControls()"
                            :prop-load-func="onGridLoaded"
                            :prop-from-main-grid="onGridLoaded"
                            :prop-dbl-click-fnc="dblClickFnc"
                            :prop-custom-ctx-menu="customCtxMenu"
                            :prop-ctx-click-fnc="ctxClickFnc"
                            :prop-ctx-menu-open-fnc="ctxMenuOpenFnc"
                            ></grid-main>
                        </div>
                        <div class="clearfix"></div>
                    </div>
                </div>`,
    controls: []
};

const editorSettings = {};

let vmsAffiliationGridCmp = {
    name: 'vmsAffiliationGrid',
    editorSettings,
    props: {
        fromMainGrid: {
            default: false
        }
    },
    data() {
        return {
            leftMenu: [],
            reloadButtons: false,
            selectedItems: {},
            selectedItemsFullData: [],
            customCtxMenu: [
                { title: 'Edit Volunteer', action: 'AFFGRID_VOLUNTEER_EDIT' },
                { title: 'Edit Organization', action: 'AFFGRID_ORGANIZATION_EDIT' },
                { title: 'Edit Activity', action: 'AFFGRID_ACTIVITY_EDIT' },
                { title: 'Edit Affiliation', action: 'AFFGRID_EDIT' },
                { title: 'Copy to clipboard', action: 'clipboard' },
            ]
        };
    },
    computed: {
        selectedByPsp() {
            let selectedCount = this.selectedItemsFullData?.length || 0;
            let selectedByPsp = {
                'vol': 0,
                'opp': 0,
                'org': 0,
                'aff': 0,
                'ae': 0,
            };
            if (selectedCount === 1) {
                for (let i in selectedByPsp) {
                    if (parseInt(this.selectedItemsFullData[0][i + 'ID'], 10) > 0) {
                        selectedByPsp[i] = parseInt(this.selectedItemsFullData[0][i + 'ID'], 10);
                    }
                }
            }
            return selectedByPsp;
        }
    },
    methods: {
        prepareLeftMenu(buttons) {
            this.reloadButtons = true;
            let tmpControls = [];
            for (let i in buttons) {
                if (i === 'length') continue;
                tmpControls.push(
                    {
                        name: buttons[i].name,
                        type: 'button',
                        label: buttons[i].title,
                        width: '100%',
                        onclick: this.doAction,
                        additionalData: library.cloneObj(buttons[i])
                    }
                );
            }
            tmpControls.forEach((control) => {
                let controlStoreIndex = createStoreIndex(this.storeId, control.name);
                controlStore().addControl(control, this, controlStoreIndex);
            });
            this.reloadButtons = false;
            this.leftMenu = tmpControls;
        },
        disableControls() {
            let buttons = this.leftMenu;
            for (let i in buttons) {
                if (i === 'length') continue;
                if (this.controls[buttons[i].name]) {
                    let display = true;
                    this.controls[buttons[i].name].disabled = this.isControlDisabled(buttons[i].name, true);
                    this.controls[buttons[i].name].display = display;
                }
            }
        },
        isControlDisabled(name, checkBySelected) {
            if (!this.controls[name]) return false;
            let selectedCount = this.selectedItemsFullData.length || 0;
            let disable = false;
            if (this.controls[name].additionalData) {
                if (
                    (checkBySelected && !selectedCount && this.controls[name].additionalData.needSelected) // need selected at least one
                    || (checkBySelected && selectedCount !== 1 && this.controls[name].additionalData.needOneSelected) // need selected only one
                    || (this.controls[name].additionalData.needSelectedPsp && !this.selectedByPsp[this.controls[name].additionalData.needSelectedPsp]) // need other psp id
                ) {
                    disable = true;
                } else {
                    disable = false;
                }
            }
            return disable;
        },
        doAction(ev, control) {
            if (typeof this[control?.additionalData?.type] === 'function') {
                this[control.additionalData.type](ev, control);
            }
        },
        ctxMenuOpenFnc(event, selectedItemsFullData, grid) {
            if (typeof grid?.ej2Instances?.contextMenuModule?.contextMenu?.hideItems === 'function') {
                let hideItems = [];
                let showItems = [];
                for (let i in this.customCtxMenu) {
                    if (this.isControlDisabled(this.customCtxMenu[i].action)) {
                        hideItems.push(this.customCtxMenu[i].action);
                    } else {
                        showItems.push(this.customCtxMenu[i].action);
                    }
                }
                if (hideItems.length) {
                    grid.ej2Instances.contextMenuModule.contextMenu.hideItems(hideItems, true);
                }
                if (showItems.length) {
                    grid.ej2Instances.contextMenuModule.contextMenu.showItems(showItems, true);
                }
            }
        },
        ctxClickFnc(controlName, selectedItemsFullData) {
            if (!this.controls[controlName.toUpperCase()]) return;
            this.edit(selectedItemsFullData, this.controls[controlName.toUpperCase()]);
        },
        onGridLoaded() {
            this.disableControls();
            this.resizeToContent();
        },
        history() {
            if (this.selectedItemsFullData && this.selectedItemsFullData.length) {
                let payload = {
                    componentId: 'itemList_affiliation_history__' + library.getUniqueID(),
                    contextRecordIds: { affId: this.selectedItemsFullData[0].rowID },
                    dialogSettings: { title: 'Affiliation History' },
                    component: this
                };
                actionStore.openComponentDialog(payload, this);
            }
        },
        async delete() {
            if (this.selectedItemsFullData && this.selectedItemsFullData.length) {
                let affListToDelete = [];
                for (let i in this.selectedItemsFullData) {
                    if (i === 'length') continue;
                    affListToDelete[affListToDelete.length] = this.selectedItemsFullData[i].rowID;
                }
                if (affListToDelete.length) {
                    let title = await ddStore.getAlias('COMMON', 'ERRORMESSAGE_DELETE_THE_TITLE');
                    let message = '';
                    if (affListToDelete.length === 1) {
                        message = await ddStore.getAlias('COMMON', 'ERRORMESSAGE_DELETE', 'affiliation');
                    } else {
                        message = await ddStore.getAlias('COMMON', 'ERRORMESSAGE_MULTIDELETE', 'affiliations');
                    }
                    library.showDialog(message, async () => {
                        await this.sDs.post('sds_deleteAffiliation', affListToDelete, 'vol_org');
                        this.getRecordsLists();
                    }, false, { title: title });
                }
            }
        },
        dblClickFnc(rowId, selectedItemsFullData) {
            this.edit(selectedItemsFullData);
        },
        async edit(selectedItemsFullData, button) {
            let recordPsp = button?.additionalData?.needSelectedPsp || 'aff';
            let tmpSelectedItemsFullData = selectedItemsFullData && selectedItemsFullData.rowID ? [selectedItemsFullData] : this.selectedItemsFullData;
            if (tmpSelectedItemsFullData && tmpSelectedItemsFullData.length) {
                if (recordPsp === 'aff') {
                    if (tmpSelectedItemsFullData.length !== 1) {
                        let title = await ddStore.getAlias('COMMON', 'ERRORMESSAGE_TITLE');
                        let msg = await ddStore.getAlias('COMMON', 'ERRORMESSAGE_EMPTY_3', 'affiliation');
                        library.showDialog(msg, false, false, { title: title, showAsAlert: true });
                        return;
                    }
                    let response = await actionStore.editAffiliation({ affID: tmpSelectedItemsFullData[0].rowID });
                    if (response && response.status !== 'failure') {
                        this.getRecordsLists();
                    }
                } else {
                    let recordID = tmpSelectedItemsFullData[0][recordPsp + 'ID'];
                    if (recordPsp && parseInt(recordID, 10) > 0) {
                        await actionStore.openProfile({ recordPsp: recordPsp, recordId: recordID });
                    }
                }
            }
        },
        async email() {
            let affIDs = [];
            if (this.selectedItemsFullData && this.selectedItemsFullData.length) {
                this.selectedItemsFullData.forEach((item) => {
                    affIDs.push(item.ID);
                });
            }
            actionStore.openEmail({ psp: 32, recordId: affIDs, allIDs: true });
        },
        async automation() {
            let affIDs = [];
            if (this.selectedItemsFullData && this.selectedItemsFullData.length) {
                this.selectedItemsFullData.forEach((item) => {
                    affIDs.push(item.ID);
                });
            }
            await actionStore.openAutomationRun({ psp: 32, recordId: affIDs });
        },
        async refresh() {
            if (typeof doAction !== 'function') return;
            doAction('refresh');
        },
        resizeToContent() {
            // eslint-disable-next-line camelcase
            if (typeof profile_getFormObject === 'function') {
                let theForm = profile_getFormObject();
                if (theForm && theForm.recordID) {
                    // eslint-disable-next-line camelcase
                    if (typeof SmartTabs === 'object' && typeof general_resizeToContent === 'function') {
                        general_resizeToContent(1, 0, 5);
                    }
                }
            }
        },
        async onLoad() {
            let mainGridData = await this.sDs.post('ec_getMainGridInfo', 32, ['menuLeft']);
            if (mainGridData.status === 'success' && mainGridData?.data?.menuLeft) {
                this.prepareLeftMenu(mainGridData.data.menuLeft);
            }
        },
        async getRecordsLists() {
            if (typeof this?.$refs?.['grid_mainGrid__AFF']?.getGridData === 'function') this.$refs['grid_mainGrid__AFF'].getGridData(true);
        },
        async report() {
            let params = {};
            let act = 'DataGridReport';
            params.openInSameWindow = true;
            params.psp = 32;
            params.isMainGrid = true;
            params.actVal = act;
            params.recordId = this.selectedItems;
            params.hideOpenInNewWindow = true;
            if (typeof params.dialogSettings === 'undefined') params.dialogSettings = {};
            params.dialogSettings.cssClass = "show-only-content-popup iframe-popup";
            await actionStore.actions.iframeProcessSubmit(act, params, params.width, params.height);
        }
    },
    components: {
        "ejs-tab": defineAsyncComponent(() => import('@common/syncfusion/tab')),
        "e-tabitems": TabItemsDirective,
        "e-tabitem": TabItemDirective
    }
};

componentStore.initComponent(vmsAffiliationGridCmp, vmsAffiliationGridConfig);
export { vmsAffiliationGridCmp, vmsAffiliationGridConfig };
export default vmsAffiliationGridCmp;

</script>

<style scoped>
:deep(.vms-affiliation-grid-settings) {
    position: absolute;
    z-index: 999999;
    left: 300px;
    top: -40px;
}
:deep(.vms-affiliation-grid-settings > *) {
    float: left;
    margin: 0 5px;
}
:deep(.vms-affiliation-grid-parts) {
    display: flex;
}
:deep(.leftcolumn > *) {
    margin-top: 5px;
    padding-left: 10px;
    padding-right: 10px;
}

:deep(.leftcolumn > .control) {
    width: 135px;
    margin: 0 10px;
    margin-bottom: 5px;
}

:deep(.from-main-grid .leftcolumn > .control) {
    width: 135px;
    margin: 0 10px;
    margin-bottom: 5px;
}

:deep(.from-main-grid .leftcolumn .e-btn:disabled) {
    background-color: #a5b3ba !important;
    color: #48565d !important;
}

:deep(.rightcolumn) {
    flex-grow: 12;
    max-width: 90%;
    width: 900px;
    overflow: hidden;
}
:deep(.from-main-grid .rightcolumn) {
    flex-grow: 12;
    width: 1300px;
    overflow: hidden;
    background-color: white;
}
:deep([cid=gridMain_mainGrid__AFF]) {
    width: 100%;
}
:deep(.e-tab-header .e-items) {
    float: left !important;
}

:deep(.e-row) {
    background-color: #f9f9f9;
    font-size: 13px;
    font-weight: 400;
}
:deep(.e-row), :deep(.e-rowcell), :deep(.e-columnheader), :deep(.e-filterbar) {
    height: 32px !important;
}
:deep(.e-filterbarcell) {
    padding: 0 3px !important;
}
:deep(.grid-wrapper .e-checkbox-wrapper .e-frame.e-icons) {
    width: 14px;
    height: 14px;
    font-size: 7px;
    line-height: 7px;
}
:deep(.grid-wrapper .e-checkbox-wrapper) {
    width: 14px;
    height: 14px
}
:deep(.rightcolumn > div) {
    float: left;
}
:deep(.e-row *) {
    font-size: 13px;
    font-weight: 400;
}
:deep(.e-altrow) {
    background-color: #fff;
}

:deep(.e-row:hover) {
    background-color: rgb(254,255,234);
}

:deep(.e-row:hover td) {
    background-color: transparent !important;
}

:deep(.e-columnheader  *) {
    background-color: #607D8B !important;
    color: #fff;
}

:deep(.e-selectionbackground) {
    color: #303030 !important;
    background-color: #e5f7fe !important;
}

:deep(.grid-wrapper) {
    margin: 5px;
    overflow: auto;
}

:deep(.e-columnheader .e-frame) {
    color: #fff !important;
    border-color: #fff !important;
}
:deep(.vms-affiliation-grid-wrapper) {
    width: 100%;
    min-width: 1555px;
}
:deep(.vms-affiliation-grid-wrapper *) {
    text-transform: unset !important;
}

:deep(.e-rowcell),
:deep(.e-filterbarcell) {
    border-right: 1px dashed #d6d6d6 !important;
}
:deep(#gridMain_mainGrid__AFF) {
    float: left;
}
</style>
